import { BrightcovePlayer } from "@components/Blocks/BrightcoveVideo/BrightcoveVideo";
import { RefObject } from "react";

type PlayerItem = {
  type: "brightcove" | "beyondwords";
  pause: () => void;
  playerRef: RefObject<BrightcovePlayer | HTMLDivElement | null>;
};

class MediaController {
  private activePlayer: PlayerItem | null = null;

  register(player: PlayerItem) {
    return {
      onPlay: () => {
        if (this.activePlayer && this.activePlayer !== player) {
          this.activePlayer.pause();
        }
        this.activePlayer = player;
        window.dispatchEvent(
          new CustomEvent("pauseAllPlayers", {
            detail: { source: player.playerRef },
          }),
        );
      },
      onPause: () => {
        if (this.activePlayer === player) {
          this.activePlayer = null;
        }
      },
    };
  }
}

export default new MediaController();
